import { Component, ViewChild } from '@angular/core';
import { PgErrorsComponent } from 'pg-lib/pg-help/pg-errors/pg-errors.component';
import { ExternalLinksService } from 'pg-lib/pg-ui-elements/external-links.service';
import { EnvironmentDataAppMode, EnvironmentService } from 'pg-lib/services/environment.service';
import { LocalizationService } from 'pg-lib/services/localization.service';
import { Websocket2Registration, Websocket2Service } from 'pg-lib/services/websocket2.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
    title = 'totem';
    
    constructor(private environmentService:EnvironmentService, private externalLinksService:ExternalLinksService, private localizationService:LocalizationService, private websocket2Service:Websocket2Service) {}

    isEnabled = false;

    isLoading = false;

    appMode:EnvironmentDataAppMode = null;

    isSwitchingLanguage = false;

    registration:Websocket2Registration = null;

    ngOnInit(): void {
        // Totem shell must render even when websocket is unavailable (tourist web login).
        this.isEnabled = true;
        this.appMode = this.environmentService.environment.AppMode || 'web';

        if(this.environmentService.isWebsocketEnabled()) {
            if(this.environmentService.environment.AppMode == 'kiosk') {
                this.externalLinksService.setExternalLinkHandler((url:string) => {
                    this.showLinkQR(url);
                })

                this.registration = this.websocket2Service.register('totem', { name: this.environmentService.environment.AppName, version: this.environmentService.getVersionString() })
    
                this.registration.statusChange.subscribe((data) => {
                    if(data == 'registered') {
                        this.registration.send({ action: 'totem-set-frontend', content: { version: this.environmentService.getVersionString(), time: this.environmentService.getBuildTime() }})
        
                        this.wsSendStatus()
                    }
                })
        
                this.registration.onMessage.subscribe((data) => {
                    if(data.action == 'admin-reload-totem') {
                        window.location.reload();
                    }
                })
            }
        }

        this.localizationService.currentLanguageChange.subscribe((status) => {
            this.isSwitchingLanguage = true;
            setTimeout(() => {
                this.isSwitchingLanguage = false;
            }, 250)
        })
    }

    ngOnDestroy(): void {
        if(this.registration != null) {
            this.registration.unregister();
        }
    }

    wsSendStatus() {
        if(this.registration != null) {
            this.registration.send({ action: 'totem-set-status', content: 'online' })
        }
    }

    wsSendActivity() {
        if(this.registration != null) {
            this.registration.send({ action: 'totem-activity' })
        }
    }

    externalLinkUrl:string = null;
    
    showLinkQR(url:string) {
        this.externalLinkUrl = url;
    }

    isUnderMaintenance() {
        return this.environmentService.getTimeUntilManteinance() <= 0;
    }

    hasErrors() {
        return (this.errorsComponent != null && this.errorsComponent.errors.length > 0);
    }

    @ViewChild('errorsComponent') errorsComponent:PgErrorsComponent
}
